import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {Box, Typography,} from "@mui/material";
import {correctName, formatNumber, formatPercentage, getNomElection, getTrendIcon, tours} from "../Utils";


export default function Synthese({results, stats, electionType}) {


    function getAnalyseEvolNuance() {
        let nuance20 = results[0].nuance.name
        let nuanceOld = nuance20;
        if (results.length > 1) {
            nuanceOld = results[1].nuance.name
        }
        if (nuance20 !== nuanceOld) {
            return (
                <Box sx={{width: "calc(100% - 560px)", display: "flex", flexDirection: "row"}}>

                    <Typography variant={"body"} sx={{
                        color: "#f40a06",
                        fontWeight: 400,
                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                        fontStyle: "normal",
                    }}>
                        Changement de nuance politique entre les deux dernieres elections
                    </Typography>
                </Box>
            )
        }
        return (<Box sx={{width: "100%", display: "flex", flexDirection: "row"}}>
        </Box>);
    }

    if (results) {

        return (

            <Box sx={{
                display: "flex", flexDirection: "column",
                alignItems: "center",
                gap: 1,
                width: "100%",

            }}>
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                    <Box sx={{display: "flex", flexDirection: "column", gap: 1, width: "80%"}}>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between"}}>
                            <Typography sx={{
                                width: {md: 60, lg: 80, xl: 100},
                                color: "#000",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                {getNomElection[electionType]}
                            </Typography>

                            <Typography sx={{
                                width: {md: 70, lg: 80, xl: 120},
                                color: "#000",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                Victoire
                            </Typography>
                            <Typography sx={{
                                width: {md: 80, lg: 100, xl: 300},
                                color: "#000",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                Gagnant
                            </Typography>
                            <Typography sx={{
                                width: {md: 80, lg: 100, xl: 300},
                                color: "#000",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                Nuance Politique
                            </Typography>
                            <Typography sx={{
                                width: {md: 60, lg: 80, xl: 100},
                                color: "#000",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                Abstention
                            </Typography>
                        </Box>
                        {results.map((result, index) => {
                            return (
                                <Box key={index} sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    justifyContent: "space-between"
                                }}>
                                    <Typography sx={{
                                        width: {md: 60, lg: 80, xl: 100},
                                        color: "#666",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                    }}>
                                        {result.year}
                                    </Typography>

                                    <Typography sx={{
                                        width: {md: 70, lg: 80, xl: 120},
                                        color: "#666",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                    }}>
                                        {tours[result.tour]}
                                    </Typography>
                                    <Typography sx={{
                                        width: {md: 80, lg: 100, xl: 300},
                                        color: "#666",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        display: "flex",
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                    }}>
                                        <Box sx={{
                                            width: 8,
                                            height: 20,
                                            backgroundColor: result.winner.color,

                                            marginRight: 1
                                        }}/>

                                        {correctName(result.winner.nomPrenom)}
                                        &nbsp;({formatPercentage(result.winner.perc)})

                                    </Typography>
                                    <Typography sx={{
                                        width: {md: 80, lg: 100, xl: 300},
                                        color: "#666",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        display: "flex",
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                    }}>
                                        <Box sx={{
                                            width: 20,
                                            height: 20,
                                            backgroundColor: result.nuance.color,
                                            borderRadius: 25,
                                            marginRight: 1
                                        }}/>
                                        {result.nuance.name}
                                    </Typography>
                                    <Typography sx={{
                                        width: {md: 60, lg: 80, xl: 100},
                                        color: "#666",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        display: "flex",
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                    }}>
                                        {getTrendIcon(result.abstention.trendPerc, true)}
                                        {formatPercentage(result.abstention.perc)}
                                    </Typography>
                                </Box>)
                        })}
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "column", gap: 1, width: "20%"}}>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2}}>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},

                            }}>
                                &nbsp;
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>

                                Rang
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>

                                Valeur
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>
                                Part
                            </Typography>
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2}}>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                Inscrits
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>

                                {stats.inscrit.rang}
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>

                                {formatNumber(stats.inscrit.nb)}
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>
                                {formatPercentage(stats.inscrit.percent)}
                            </Typography>
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2}}>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            }}>
                                Abst.

                            </Typography>

                            <Box sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"


                            }}>

                                {stats.abstention.rang}
                            </Box>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>

                                {formatNumber(stats.abstention.nb)}
                            </Typography>
                            <Typography sx={{
                                width: {md: 25, lg: 32, xl: 50},
                                color: "#666",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                                display: "flex", justifyContent: "center"
                            }}>
                                {formatPercentage(stats.abstention.percent)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row", gap: 1, width: "100%"}}>
                    <Box sx={{width: 560}}>
                        &nbsp;
                    </Box>
                    {getAnalyseEvolNuance()}
                </Box>
            </Box>
        );
    }
}

